import React from 'react'
import { Link as AnchorLink } from 'react-scroll'
import MobileMenu from '../mobile-menu'

const Menu = () => {
  const duration = 300
  const offset = -80

  const menuEntries = [
    { label: 'Crawling Result', target: 'crawling-result' },
    { label: 'New Pages', target: 'new-pages' },
    { label: 'Lost Pages', target: 'lost-pages' },
    { label: 'Changes', target: 'changes' },
    { label: 'Onpage Issues', target: 'onpage-issues' },
    { label: 'Link Checker', target: 'link-checker' },
    { label: 'About', target: 'about' },
  ]

  return (
    <div className="menu-wrapper">
      <div className="menu">
        <ul>
          {menuEntries.map(element => {
            return (
              <li key={element.target}>
                <AnchorLink to={element.target} smooth={true} duration={duration} offset={offset}>
                  {element.label}
                </AnchorLink>
              </li>
            )
          })}
        </ul>
      </div>
      <MobileMenu entries={menuEntries} />
    </div>
  )
}

export default Menu
